import {StudentServices} from '@/plugins/api'
import {get} from 'lodash'
import alert from '@/plugins/alert'

export default {
  namespaced: true,
  state: {
    submitState: 0,
    isConfirmedExpectation: false,
    isConfirmedService: false,
    isDocumentPreview: false,
    hasPermissionAction: false,
    isEditing: false,
    isExpectationPreview: false,
    isServicePreview: false,
    diffReductionAmount: 0,
    subjectGroupResetNotice: null,
    //
    serviceForm: {}
  },
  actions: {
    changeSubmitState({commit}, submitState = 0) {
      commit('changeState', {submitState})
    },
    changeIsConfirmedExpectation({commit}, isConfirmedExpectation = false) {
      commit('changeState', {isConfirmedExpectation})
    },
    changeIsConfirmedService({commit}, isConfirmedService = false) {
      commit('changeState', {isConfirmedService})
    },
    async fetchSingleForm({commit}, cv = '') {
      const res = await StudentServices.fetch({cv})
      commit('changeState', {serviceForm: null})
      let diffReductionAmount = 0
      try {
        diffReductionAmount = await StudentServices.getDiffReductionAmount({cvId: cv})
      } catch (error) {
        console.error(error)
      }
      
      const serviceForm = get(res, '0', {})
      const state = get(serviceForm, 'state', 0)

      let submitState = state
      const isServicePaid = get(serviceForm, 'isServicePaid', false)
      if (isServicePaid) {
        const type = get(serviceForm, 'type')
        if (type === 'high') submitState = 3
        else submitState = 2
        alert.success('XEM VÀ IN GIẤY HẸN NỘP HỒ SƠ GỐC NGAY BÂY GIỜ')
        commit('changeState', {submitState})
      }

      commit('changeState', {
        serviceForm,
        isConfirmedExpectation: get(serviceForm, 'filledSubjectGroupForm', false),
        isConfirmedService: get(serviceForm, 'filledServiceForm', false),
        isExpectationPreview: state > 0,
        isServicePreview: get(serviceForm, 'isServicePaid', false),
        // submitState,
        diffReductionAmount
      })
    },
    async resetSubjectGroupRegistration({commit}, {cv = '', studentCode = ''} = {}) {
      try {
        const forms = await StudentServices.fetch({cv})
        const serviceForm = get(forms, '0', {})
        const serviceFormId = get(serviceForm, 'id') || get(serviceForm, '_id')
        const hasSubjectGroupRegistration =
          get(serviceForm, 'filledSubjectGroupForm', false) ||
          get(serviceForm, 'subjectGroupFormUrl', '') ||
          get(serviceForm, 'subjectGroup1', '') ||
          get(serviceForm, 'subjectGroup2', '') ||
          get(serviceForm, 'subjectGroup3', '')

        if (!serviceFormId || !hasSubjectGroupRegistration) return false

        const resetData = {
          id: serviceFormId,
          cv,
          studentCode,
          type: 'high',
          state: 0,
          subjectGroupType: null,
          subjectGroup1: null,
          subjectGroup2: null,
          subjectGroup3: null,
          subjectGroupFormUrl: null,
          filledSubjectGroupForm: false,
          updateSubjectGroupDate: null,
        }

        let updatedServiceForm = null
        try {
          updatedServiceForm = await StudentServices.update(serviceFormId, {
            'not-clear-request': true,
            ...resetData,
          })
        } catch (error) {
          updatedServiceForm = await StudentServices.updateServices10(resetData)
        }

        commit('changeState', {
          serviceForm: updatedServiceForm || {...serviceForm, ...resetData},
          isConfirmedExpectation: false,
          isExpectationPreview: false,
          submitState: 1,
          subjectGroupResetNotice: {
            cv,
            studentCode,
            changedAt: Date.now(),
          },
        })

        return true
      } catch (error) {
        alert.error(error)
        return false
      }
    },
    clearSubjectGroupResetNotice({commit}) {
      commit('changeState', {subjectGroupResetNotice: null})
    },
    changeIsDocumentPreview({commit}, isDocumentPreview = false) {
      commit('changeState', {isDocumentPreview})
    },
    changeIsEditing({commit}, isEditing = false) {
      commit('changeState', {isEditing})
    },
    changeIsExpectationPreview({commit}, isExpectationPreview = false) {
      commit('changeState', {isExpectationPreview})
    },
    changeIsServicePreview({commit}, isServicePreview = false) {
      commit('changeState', {isServicePreview})
    },
    changeHasPermissionAction({commit}, hasPermissionAction = false) {
      commit('changeState', {hasPermissionAction})
    }
  },
  getters: {
    submitState: state => state.submitState,
    isConfirmedExpectation: state => state.isConfirmedExpectation,
    serviceForm: state => state.serviceForm,
    isConfirmedService: state => state.isConfirmedService,
    isDocumentPreview: state => state.isDocumentPreview,
    isEditing: state => state.isEditing,
    isExpectationPreview: state => state.isExpectationPreview,
    isServicePreview: state => state.isServicePreview,
    hasPermissionAction: state => state.hasPermissionAction,
    diffReductionAmount: state => state.diffReductionAmount,
    subjectGroupResetNotice: state => state.subjectGroupResetNotice
  }
}
